import {post, postForm, get} from '../http';
import {GenericHttpError} from '../../errors';

export default {

	deployTest(request) {
		const {authorizationToken, ...data} = request;
		return postForm(`${__API_URL__}/configuration/deployTest`, data, authorizationToken)
			.then((result: ConfigTester.DeployResponse) => {
				if (!result.success) {
					throw new GenericHttpError(400, 'Failed to deploy configuration', result);
				} else {
					return result;
				}
			});
	},

	deploy(request: any): Promise<ConfigTester.DeployResponse> {
		const {authorizationToken, ...data} = request;
		return postForm(`${__API_URL__}/configuration/deploy`, data, authorizationToken);
	},

	updateExternalServiceIntegrations(request) {
		const {authorizationToken, ...data} = request;
		return post(`${__API_URL__}/configuration/updateExternalServiceIntegrations`, data, authorizationToken)
			.then((result: ConfigTester.DeployResponse) => {
				if (!result.success) {
					throw new GenericHttpError(400, 'Failed to deploy configuration', result);
				} else {
					return result;
				}
			});
	},

	getTenantHostname(authorizationToken: string) {
		return post(`${__STUDIO_URL__}/configeditor/hostname`, {}, authorizationToken)
			.catch(error => {
				console.error('Unable to get tenant hostname', error);
			});
	},

	getTenantIdForTenantName(tenantName: string, authorizationToken: string) {
		return get(`${__API_URL__}/tenant/v1/findByHostname?hostname=${tenantName}`, authorizationToken)
			.catch(error => {
				console.error('Unable to get tenant id', error);
			});
	},

	getTenantFFs(authorizationToken: string, tenantLocator: string) {
		return get(`${__API_URL__}/tenant/v1/tenant/locator/config/properties?tenantLocator=${tenantLocator}`,
			authorizationToken)
			.catch(error => {
				console.error('Unable to get tenant configuration', error);
			});
	},

} as ConfigTester.DeployApi;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/api/config-tester/deploy.ts